import atomize from "@quarkly/atomize";
export default atomize.hr({
  name: "Hr",
  normalize: true,
  mixins: true,
  description: {
    en: "hr element — horizontal line to separate content",
    ru: "Элемент hr — разделительная линия"
  },
  propInfo: {}
}, {
  "margin-top": "16px",
  "margin-bottom": "16px",
  "padding-bottom": "4px",
  "border-width": "1px 0 0 0",
  "border-style": "solid",
  "border-color": "--color-lightD2"
});